import { Locale } from 'chaika-enums';
export const dictaphone = {
    dictaphoneConfirmModalTitle: {
        [Locale.Ru]: 'Добавить расшифровку в запись',
        [Locale.Am]: 'Ավելացնել վերծանումը գրառմանը',
        [Locale.En]: 'Add transcription to entry',
        [Locale.Pt]: 'Adicionar transcrição à entrada',
        [Locale.Ge]: 'Add transcription to entry',
    },
    dictaphoneConfirmButton: {
        [Locale.Ru]: 'Добавить',
        [Locale.Am]: 'Ավելացնել',
        [Locale.En]: 'Add',
        [Locale.Pt]: 'Adicionar',
        [Locale.Ge]: 'Add',
    },
    dictaphoneCancelButton: {
        [Locale.Ru]: 'Отменить',
        [Locale.Am]: 'Չեղարկել',
        [Locale.En]: 'Cancel',
        [Locale.Pt]: 'Cancelar',
        [Locale.Ge]: 'Cancel',
    },
    dictaphonePreviewLoading: {
        [Locale.Ru]: 'Загрузка превью…',
        [Locale.Am]: 'Նախադիտման բեռնում…',
        [Locale.En]: 'Loading preview…',
        [Locale.Pt]: 'Carregando pré-visualização…',
        [Locale.Ge]: 'Loading preview…',
    },
    dictaphoneEmptyTranscription: {
        [Locale.Ru]: 'В расшифровке нет текста для добавления.',
        [Locale.Am]: 'Վերծանման մեջ ավելացնելու տեքստ չկա։',
        [Locale.En]: 'Transcription has no content to add.',
        [Locale.Pt]: 'A transcrição não tem conteúdo a adicionar.',
        [Locale.Ge]: 'Transcription has no content to add.',
    },
    dictaphoneEpisodeWillBeCreated: {
        [Locale.Ru]: 'Будет создан эпизод',
        [Locale.Am]: 'Կստեղծվի էպիզոդ',
        [Locale.En]: 'A new episode will be created',
        [Locale.Pt]: 'Um novo episódio será criado',
        [Locale.Ge]: 'A new episode will be created',
    },
    dictaphoneEpisodeNameLabel: {
        [Locale.Ru]: 'Название:',
        [Locale.Am]: 'Անվանում՝',
        [Locale.En]: 'Name:',
        [Locale.Pt]: 'Nome:',
        [Locale.Ge]: 'Name:',
    },
    dictaphoneEpisodeDescriptionLabel: {
        [Locale.Ru]: 'Описание:',
        [Locale.Am]: 'Նկարագրություն՝',
        [Locale.En]: 'Description:',
        [Locale.Pt]: 'Descrição:',
        [Locale.Ge]: 'Description:',
    },
    dictaphoneCurrentValueLabel: {
        [Locale.Ru]: 'Текущее значение:',
        [Locale.Am]: 'Ընթացիկ արժեք՝',
        [Locale.En]: 'Current value:',
        [Locale.Pt]: 'Valor atual:',
        [Locale.Ge]: 'Current value:',
    },
    dictaphoneAppendOnNewLine: {
        [Locale.Ru]: 'Добавить с новой строки:',
        [Locale.Am]: 'Ավելացնել նոր տողից՝',
        [Locale.En]: 'Append on a new line:',
        [Locale.Pt]: 'Anexar em uma nova linha:',
        [Locale.Ge]: 'Append on a new line:',
    },
    dictaphoneWillBeInserted: {
        [Locale.Ru]: 'Будет вставлено:',
        [Locale.Am]: 'Կտեղադրվի՝',
        [Locale.En]: 'Will be inserted:',
        [Locale.Pt]: 'Será inserido:',
        [Locale.Ge]: 'Will be inserted:',
    },
    dictaphoneRecommendations: {
        [Locale.Ru]: 'Рекомендации',
        [Locale.Am]: 'Հանձնարարականներ',
        [Locale.En]: 'Recommendations',
        [Locale.Pt]: 'Recomendações',
        [Locale.Ge]: 'Recommendations',
    },
    dictaphoneRecommendationsHint: {
        [Locale.Ru]: 'будут привязаны к эпизоду',
        [Locale.Am]: 'կկապվեն էպիզոդին',
        [Locale.En]: 'will be linked to the episode',
        [Locale.Pt]: 'serão vinculados ao episódio',
        [Locale.Ge]: 'will be linked to the episode',
    },
    dictaphoneFollowUpTasks: {
        [Locale.Ru]: 'Задания и контрольные явки',
        [Locale.Am]: 'Առաջադրանքներ և հսկիչ այցեր',
        [Locale.En]: 'Follow-up tasks',
        [Locale.Pt]: 'Tarefas de acompanhamento',
        [Locale.Ge]: 'Follow-up tasks',
    },
    dictaphoneDrugs: {
        [Locale.Ru]: 'Медикаменты',
        [Locale.Am]: 'Դեղամիջոցներ',
        [Locale.En]: 'Medications',
        [Locale.Pt]: 'Medicamentos',
        [Locale.Ge]: 'Medications',
    },
    dictaphoneDrugsHint: {
        [Locale.Ru]: 'будут добавлены в заметку (требуется ручное создание с выбором действующего вещества из словаря)',
        [Locale.Am]: 'կավելացվեն նշման մեջ (պահանջվում է ձեռքով ստեղծում՝ բառարանից ակտիվ նյութի ընտրությամբ)',
        [Locale.En]: 'will be added to the note (manual creation with active substance from the dictionary is required)',
        [Locale.Pt]: 'serão adicionados à nota (é necessária criação manual com substância ativa do dicionário)',
        [Locale.Ge]: 'will be added to the note (manual creation with active substance from the dictionary is required)',
    },
    dictaphoneDiagnoses: {
        [Locale.Ru]: 'Диагнозы',
        [Locale.Am]: 'Ախտորոշումներ',
        [Locale.En]: 'Diagnoses',
        [Locale.Pt]: 'Diagnósticos',
        [Locale.Ge]: 'Diagnoses',
    },
    dictaphoneDiagnosesHint: {
        [Locale.Ru]: 'с МКБ-10 будут привязаны к эпизоду, без — попадут в заметку',
        [Locale.Am]: 'ՀՄԴ-10-ով կկապվեն էպիզոդին, առանց — կընկնեն նշման մեջ',
        [Locale.En]: 'with ICD-10 will be linked to the episode, without — added to the note',
        [Locale.Pt]: 'com CID-10 serão vinculados ao episódio, sem — irão para a nota',
        [Locale.Ge]: 'with ICD-10 will be linked to the episode, without — added to the note',
    },
    dictaphoneReferrals: {
        [Locale.Ru]: 'Направления',
        [Locale.Am]: 'Ուղեգրեր',
        [Locale.En]: 'Referrals',
        [Locale.Pt]: 'Encaminhamentos',
        [Locale.Ge]: 'Referrals',
    },
    dictaphoneReferralsHint: {
        [Locale.Ru]: 'будут добавлены в заметку (требуется ручная привязка к услуге)',
        [Locale.Am]: 'կավելացվեն նշման մեջ (պահանջվում է ձեռքով կապում ծառայության հետ)',
        [Locale.En]: 'will be added to the note (manual linking to a service is required)',
        [Locale.Pt]: 'serão adicionados à nota (é necessária vinculação manual a um serviço)',
        [Locale.Ge]: 'will be added to the note (manual linking to a service is required)',
    },
    dictaphoneEntryNote: {
        [Locale.Ru]: 'Заметка к приёму',
        [Locale.Am]: 'Նշում ընդունելության վերաբերյալ',
        [Locale.En]: 'Visit note',
        [Locale.Pt]: 'Nota da consulta',
        [Locale.Ge]: 'Visit note',
    },
    dictaphoneIcd10Short: {
        [Locale.Ru]: 'МКБ-10',
        [Locale.Am]: 'ՀՄԴ-10',
        [Locale.En]: 'ICD-10',
        [Locale.Pt]: 'CID-10',
        [Locale.Ge]: 'ICD-10',
    },
    dictaphoneDueLabel: {
        [Locale.Ru]: 'срок',
        [Locale.Am]: 'ժամկետ',
        [Locale.En]: 'due',
        [Locale.Pt]: 'prazo',
        [Locale.Ge]: 'due',
    },
    dictaphoneSinceLabel: {
        [Locale.Ru]: 'с',
        [Locale.Am]: 'սկսած',
        [Locale.En]: 'from',
        [Locale.Pt]: 'desde',
        [Locale.Ge]: 'from',
    },
    dictaphoneTooShortRecordingTitle: {
        [Locale.Ru]: 'Запись слишком короткая',
        [Locale.Am]: 'Ձայնագրությունը չափազանց կարճ է',
        [Locale.En]: 'Recording is too short',
        [Locale.Pt]: 'A gravação é muito curta',
        [Locale.Ge]: 'Recording is too short',
    },
    dictaphoneTooShortRecordingMessage: {
        [Locale.Ru]: 'Длительность записи $seconds сек. Расшифровка возможна только для записей длиннее $min сек.',
        [Locale.Am]: 'Ձայնագրության տևողությունը $seconds վրկ։ Վերծանումը հնարավոր է միայն $min վրկ-ից երկար ձայնագրությունների համար։',
        [Locale.En]: 'Recording length is $seconds s. Transcription requires at least $min s.',
        [Locale.Pt]: 'A duração da gravação é $seconds s. A transcrição requer pelo menos $min s.',
        [Locale.Ge]: 'Recording length is $seconds s. Transcription requires at least $min s.',
    },
    dictaphoneEmptyRecordingTitle: {
        [Locale.Ru]: 'Запись не сохранилась',
        [Locale.Am]: 'Ձայնագրությունը չի պահպանվել',
        [Locale.En]: 'Recording was not saved',
        [Locale.Pt]: 'A gravação não foi salva',
        [Locale.Ge]: 'Recording was not saved',
    },
    dictaphoneEmptyRecordingMessage: {
        [Locale.Ru]: 'Аудиофайл пуст — запись могла прерваться из-за перезагрузки или закрытия страницы. Расшифровка невозможна, удалите запись и создайте новую.',
        [Locale.Am]: 'Աուդիոֆայլը դատարկ է — ձայնագրությունը կարող էր ընդհատվել էջի վերաբեռնման կամ փակման պատճառով։ Վերծանումն անհնար է, ջնջեք ձայնագրությունը և ստեղծեք նորը։',
        [Locale.En]: 'The audio file is empty — the recording may have been interrupted by a page reload or close. Transcription is not possible, delete the recording and create a new one.',
        [Locale.Pt]: 'O arquivo de áudio está vazio — a gravação pode ter sido interrompida por recarregamento ou fechamento da página. A transcrição não é possível, exclua a gravação e crie uma nova.',
        [Locale.Ge]: 'The audio file is empty — the recording may have been interrupted by a page reload or close. Transcription is not possible, delete the recording and create a new one.',
    },
    dictaphoneStorageErrorTitle: {
        [Locale.Ru]: 'Запись остановлена',
        [Locale.Am]: 'Ձայնագրությունը դադարեցված է',
        [Locale.En]: 'Recording stopped',
        [Locale.Pt]: 'Gravação interrompida',
        [Locale.Ge]: 'Recording stopped',
    },
    dictaphoneStorageErrorMessage: {
        [Locale.Ru]: 'Не удалось сохранить аудио на диск. Записанная часть сохранена — её можно расшифровать или продолжить запись.',
        [Locale.Am]: 'Չհաջողվեց պահպանել աուդիոն սկավառակում։ Ձայնագրված մասը պահպանվել է — այն կարելի է վերծանել կամ շարունակել ձայնագրությունը։',
        [Locale.En]: 'Failed to save audio to disk. The recorded part has been saved — you can transcribe it or resume recording.',
        [Locale.Pt]: 'Falha ao salvar o áudio no disco. A parte gravada foi salva — você pode transcrevê-la ou retomar a gravação.',
        [Locale.Ge]: 'Failed to save audio to disk. The recorded part has been saved — you can transcribe it or resume recording.',
    },
    dictaphoneSilenceWarningTitle: {
        [Locale.Ru]: 'Звук не распознан',
        [Locale.Am]: 'Ձայնը չի ճանաչվել',
        [Locale.En]: 'No sound detected',
        [Locale.Pt]: 'Nenhum som detectado',
        [Locale.Ge]: 'No sound detected',
    },
    dictaphoneSilenceWarningMessage: {
        [Locale.Ru]: 'Последнюю минуту запись идёт, но звука нет. Проверьте, что микрофон включён и выбран правильный.',
        [Locale.Am]: 'Վերջին րոպեին ձայնագրությունն ընթանում է, սակայն ձայն չկա։ Ստուգեք, որ խոսափողը միացված է և ընտրված է ճիշտը։',
        [Locale.En]: 'Recording is running, but no sound has been detected for the last minute. Check that the microphone is on and the right one is selected.',
        [Locale.Pt]: 'A gravação está em andamento, mas nenhum som foi detectado no último minuto. Verifique se o microfone está ligado e se o correto está selecionado.',
        [Locale.Ge]: 'Recording is running, but no sound has been detected for the last minute. Check that the microphone is on and the right one is selected.',
    },
    dictaphoneMostlySilentConfirm: {
        [Locale.Ru]: 'Запись почти полностью тихая — возможно, микрофон не работал. Отправить её на расшифровку?',
        [Locale.Am]: 'Ձայնագրությունը գրեթե ամբողջովին լուռ է — հնարավոր է՝ խոսափողը չի աշխատել։ Ուղարկե՞լ այն վերծանման',
        [Locale.En]: 'The recording is almost completely silent — the microphone may not have been working. Send it for transcription anyway?',
        [Locale.Pt]: 'A gravação está quase completamente silenciosa — o microfone pode não ter funcionado. Enviar para transcrição mesmo assim?',
        [Locale.Ge]: 'The recording is almost completely silent — the microphone may not have been working. Send it for transcription anyway?',
    },
    dictaphoneMicrophonePermissionHint: {
        [Locale.Ru]: 'Разрешите запись голоса в настройках браузера. Переключатель у микрофона должен быть включен.',
        [Locale.Am]: 'Թույլատրեք ձայնագրումը բրաուզերի կարգավորումներում։ Խոսափողի անջատիչը պետք է միացված լինի։',
        [Locale.En]: 'Allow voice recording in your browser settings. The microphone toggle must be turned on.',
        [Locale.Pt]: 'Permita a gravação de voz nas configurações do navegador. O botão do microfone deve estar ativado.',
        [Locale.Ge]: 'Allow voice recording in your browser settings. The microphone toggle must be turned on.',
    },
    dictaphoneEpisodeWillBeAttached: {
        [Locale.Ru]: 'Запись будет добавлена в существующий эпизод',
        [Locale.Am]: 'Գրառումը կավելացվի գոյություն ունեցող էպիզոդում',
        [Locale.En]: 'The entry will be attached to an existing episode',
        [Locale.Pt]: 'A entrada será anexada a um episódio existente',
        [Locale.Ge]: 'The entry will be attached to an existing episode',
    },
    dictaphoneUploadingRecord: {
        [Locale.Ru]: 'Загрузка аудиозаписи',
        [Locale.Am]: 'Ձայնագրության վերբեռնում',
        [Locale.En]: 'Uploading the audio record',
        [Locale.Pt]: 'Carregando a gravação',
        [Locale.Ge]: 'აუდიოჩანაწერის ატვირთვა',
    },
    dictaphoneSubmittingForTranscription: {
        [Locale.Ru]: 'Отправка записи на расшифровку',
        [Locale.Am]: 'Ձայնագրության ուղարկում վերծանման',
        [Locale.En]: 'Sending the record for transcription',
        [Locale.Pt]: 'Enviando a gravação para transcrição',
        [Locale.Ge]: 'ჩანაწერის გაგზავნა გაშიფვრისთვის',
    },
    dictaphoneProcessingRecord: {
        [Locale.Ru]: 'Обработка аудиозаписи',
        [Locale.Am]: 'Ձայնագրության մշակում',
        [Locale.En]: 'Processing the audio record',
        [Locale.Pt]: 'Processando a gravação',
        [Locale.Ge]: 'აუდიოჩანაწერის დამუშავება',
    },
    dictaphoneAddDataLater: {
        [Locale.Ru]: 'Позже',
        [Locale.Am]: 'Ավելի ուշ',
        [Locale.En]: 'Later',
        [Locale.Pt]: 'Mais tarde',
        [Locale.Ge]: 'მოგვიანებით',
    },
    dictaphoneMicrophoneDeniedError: {
        [Locale.Ru]: 'Доступ к микрофону запрещён',
        [Locale.Am]: 'Խոսափողի հասանելիությունն արգելված է',
        [Locale.En]: 'Microphone access is blocked',
        [Locale.Pt]: 'O acesso ao microfone está bloqueado',
        [Locale.Ge]: 'მიკროფონზე წვდომა აკრძალულია',
    },
    dictaphonePermissionsApiUnsupportedError: {
        [Locale.Ru]: 'Ваш браузер не поддерживает Permissions API',
        [Locale.Am]: 'Ձեր բրաուզերը չի աջակցում Permissions API-ին',
        [Locale.En]: 'Your browser does not support the Permissions API',
        [Locale.Pt]: 'O seu navegador não suporta a Permissions API',
        [Locale.Ge]: 'თქვენი ბრაუზერი არ უჭერს მხარს Permissions API-ს',
    },
};
